import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';

// assets
import { faCheck, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services
import GoodsService from '../../../../../services/goods/goods';

// props
import { IGoodsResourceShortProps } from '../../../../../props/goods/goods';

// components
import { ActionButton, CommandBar, DefaultButton, ICommandBarItemProps, Panel, PanelType, Pivot, PivotItem, PrimaryButton, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import GeneralService from '../../../../../services/general';
import ErrorService from '../../../../../services/general/error';
import LoadingComponent from '../../../../feedbacks/loading';
import { IOrderContainerResourceCompleteProps, IOrderContainerResourceShortProps } from '../../../../../props/orders/containers';
import OrderContainerService from '../../../../../services/orders/orderContainer';
import ComingSoon from '../../../../uiframeworks/comingSoon';
import OrderContainerGoodsList from '../../goods/general/list';
import Details from '../../../../typography/details';

interface IOrderContainerDetailsPropertiesProps {
    container: IOrderContainerResourceCompleteProps;
}

const OrderContainerDetailsProperties: React.FC<IOrderContainerDetailsPropertiesProps> = (props: IOrderContainerDetailsPropertiesProps) => {
    const { container } = props;
    const { banner } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();

    const getSubtotal = () => {
        let subtotal = container.totalPrice;

        if (container.includePPn) {
            subtotal -= container.ppn;
        }
        if (container.includePPh) {
            subtotal -= container.pph;
        }

        return subtotal;
    }

    return <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 10 } }}>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={'Container number'} text={container.containerNumber || "-"} style={{width: '50%'}} />
            <Details title={'Container size'} text={container.size || "-"} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={'Seal number'} text={container.sealNumber || "-"} style={{width: '50%'}} />
            <Details title={'RO number'} text={container.roNumber || "-"} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={'Nama Kapal'} text={container.shipName || "-"} style={{width: '50%'}} />
            <Details title={'Voy'} text={container.voy || "-"} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={'Tipe Stuffing'} text={container.stuffingType ? (container.stuffingType === 'dalam' ? 'Stuffing Dalam (Depo Pelabuhan)' : 'Stuffing Luar (Door/Gudang)') : 'Stuffing Luar (Door/Gudang)'} style={{width: '50%'}} />
            <Details title={'Tipe Stripping'} text={container.strippingType ? (container.strippingType === 'dalam' ? 'Stripping Dalam (Depo Pelabuhan)' : 'Stripping Luar (Door/Gudang)') : 'Stripping Luar (Door/Gudang)'} style={{width: '50%'}} />
        </Stack>
        <Stack className={'divider'}></Stack>
        <Label size={'small'}>Pricing Details</Label>
        <Stack>
            <Details title={'Price'} text={`Rp. ${GeneralService.getNumberWithSeparator(container.price || "0")}`} />
            <Stack horizontal tokens={{childrenGap: 5}}>
                {container.includePPn ? <Text size={'small'} className={'color-green'}>(include PPn)</Text> : null}
                {container.includePPh ? <Text size={'small'} className={'color-green'}>(include PPh)</Text> : null}
                {!container.includePPn ? <Text size={'small'} className={'color-red'}>(exclude PPn)</Text> : null}
                {!container.includePPh ? <Text size={'small'} className={'color-red'}>(exclude PPh)</Text> : null}
            </Stack>
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`PPn (${container.ppnPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(container.ppn))}`} style={{width: '50%'}} />
            <Details title={`PPh (${container.pphPercentage}%)`} text={`Rp. ${GeneralService.getNumberWithSeparator(Number(container.pph))}`} style={{width: '50%'}} />
        </Stack>
        <Stack horizontal tokens={{childrenGap: 20}}>
            <Details title={`Price (inc. PPn & PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(container.totalPrice)}`} style={{width: '50%'}} />
            <Details title={`Invoice price (total price - PPh)`} text={`Rp. ${GeneralService.getNumberWithSeparator(container.invoicePrice)}`} style={{width: '50%'}} />
        </Stack>
        <Stack className='divider'></Stack>
        <Stack>
            <Label size={'small'}>Goods List</Label>
            <OrderContainerGoodsList orderId={props.container.orderId} containerId={props.container.id} goods={props.container.goods} />
        </Stack>
    </Stack>
};

export default OrderContainerDetailsProperties;
